
export const update = (config) => {
    return {
        type: 'UPDATE_CONFIGURATION',
        config,
    };
};

export const updateConfigurations = (configurations) => {
    return {
        type: 'UPDATE_CONFIGURATIONS',
        configurations,
    };
};

export const reset = () => {
    return {
        type: 'RESET_CONFIGURATION',
    };
};

export const resetSheds = () => {
    return {
        type: 'RESET_SHEDS',
    };
};

export const resetDocks = () => {
    return {
        type: 'RESET_DOCKS',
    };
};

export const updateWarehouses = (warehouses) => {
    return {
        type: 'UPDATE_WAREHOUSES',
        warehouses,
    };
};

export const updateDocks = (docks) => {
    return {
        type: 'UPDATE_DOCKS',
        docks,
    };
};

export const updateSheds = (sheds) => {
    return {
        type: 'UPDATE_SHEDS',
        sheds,
    };
};

export const setResources = (listResource) => {
    return {
        type: 'LIST_RESOURCE',
        listResource,
    };
};

export const setResource = (resource) => {
    return {
        type: 'SET_RESOURCE',
        resource
    };
};

export const setPrints = (listPrints) => {
    return {
        type: 'LIST_PRINT',
        listPrints,
    };
};

export const setPrint = (print) => {
    return {
        type: 'SET_PRINT',
        print
    };
};

export const setConfigsUser = (configUser) => {
    return {
        type: 'SET_CONFIG_USER',
        configUser
    };
};

export const setEquipments = (listEquipments) => {
    return {
        type: 'LIST_EQUIPMENT',
        listEquipments,
    };
};

export const setEquipment = (equipment) => {
    return {
        type: 'SET_EQUIPMENT',
        equipment
    };
};

export const setEquipmentTypes = (equipmentTypes) => {
    return {
        type: 'LIST_EQUIPMENT_TYPES',
        equipmentTypes
    };
};

export const setTokens = (listTokens) => {
    return {
        type: 'LIST_TOKENS',
        listTokens,
    };
}

export const setToken = (token) => {
    return {
        type: 'SET_TOKEN',
        token
    };
}

export const setPrintFilters = (printFilters) => {
    return {
        type: 'SET_PRINT_FILTERS',
        printFilters
    };
}

export const setResourceFilters = (resourceFilters) => {
    return {
        type: 'SET_RESOURCE_FILTERS',
        resourceFilters
    };
}

export const setAlertsPaged = (alertsEmailPaged) => {
    return {
        type: 'SET_ALERT_EMAIL_PAGED',
        alertsEmailPaged,
    };
}

